"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlsCurveName = void 0;
var BlsCurveName;
(function (BlsCurveName) {
    BlsCurveName["DEPRECATED_G1"] = "BLS12381_G1";
    BlsCurveName["DEPRECATED_G2"] = "BLS12381_G2";
    BlsCurveName["G1"] = "Bls12381G1";
    BlsCurveName["G2"] = "Bls12381G2";
})(BlsCurveName = exports.BlsCurveName || (exports.BlsCurveName = {}));
//# sourceMappingURL=BlsCurveName.js.map